export default __webpack_public_path__ + "static/media/iphone.86fec347.png";